// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gIUs","index":"styles_index__2zBvI"};